export const DraftProductStepEnum = Object.freeze({
  GENERAL: 'general',
  DETAILS: 'details',
  FORM: 'from',
});
